export const ROUTE_FOR_ASSETS = process.env.REACT_APP_API_URL.replace('/api', '');
export const ROUTES_FOR_KAZAKH_ASSETS = process.env.REACT_APP_KAZAKH_API_URL || 'https://dev-b2c.telecom.kz';

export const ROUTES = {
  START: '/',
  PARTNERS: '/partners',
  PARTNERS_ADD_PARTNER: '/partners/add-partner/:id',
  PARTNERS_ADD_PROMOTION: '/partners/add-promotion/:id',
  PARTNERS_COPY_PROMOTION: '/partners/copy-promotion/:id',
  PARTNERS_DETAIL_PROMOTION: '/partners/detail-promotion/:id',
  PARTNERS_DETAIL_PARTNER: '/partners/detail-partner/:id',
  PARTNERS_HISTORY_PROMOTION: '/partners/promotion/history/:id',
  PARTNERS_HISTORY_PARTNER: '/partners/partner/history/:id',
  PARTNERS_CREATE_PACKAGE: '/partners/create-package',
  PARTNERS_EDIT_PACKAGE: '/partners/edit-package/:id',
  BONUSES: '/bonuses',
  BONUSES_ADD_EVENT: '/bonuses/add-event/:id',
  BONUSES_COPY_EVENT: '/bonuses/copy-event/:id',
  BONUSES_DETAIL_EVENT: '/bonuses/detail-event/:id',
  BONUSES_EVENTS_HISTORY: '/bonuses/history/:id',
  BONUSES_CREATE_PACKAGE: '/bonuses/create-package',
  BONUSES_EDIT_PACKAGE: '/bonuses/edit-package/:id',
  TEAM: '/team',
  TEAM_INVITE_PERSON: '/team/invite-person',
  TEAM_PROFILE_PERSON: '/team/profile-person/:id',
  TEAM_EDIT_PROFILE_PERSON: '/team/edit-profile-person/:id',
  SUPPORT: '/support',
  SUPPORT_CREATE_APPLICATION_WITH_IIN: '/support/create/:iin/:id',
  SUPPORT_CREATE_APPLICATION_WITH_PHONE: '/support/create/:mobile_phone/:type/:id',
  SUPPORT_CREATE_APPLICATION_WITH_LC: '/support/create/:local_id/:branch_id/:id/ls',
  SUPPORT_CREATE_APPLICATION: '/support/create',
  SUPPORT_DETAIL_APPLICATION_WITH_IIN: '/support/detailapp/:iin/:id/:appID',
  SUPPORT_DETAIL_APPLICATION_WITH_PHONE: '/support/detailapp/:mobile_phone/:type/:id/:appID',
  SUPPORT_DETAIL_APPLICATION_WITH_LC: '/support/detailapp/:local_id/:branch_id/:id/:appID/ls',
  SUPPORT_DETAIL_APPLICATION: '/support/detailapp',
  SUPPORT_USER_CARD_BY_INN: '/support/user-card/:iin/:id/:tab',
  SUPPORT_USER_CARD_BY_PHONE: '/support/user-card/:mobile_phone/:type/:id/:tab',
  SUPPORT_USER_CARD_BY_LC: '/support/user-card/:local_id/:branch_id/:id/:tab/ls',
  SUPPORT_USER_CARD: '/support/user-card',
  LOGIN: '/auth/login',
  REGISTRATION: '/auth/registration',
  RECOVER_PASSWORD_EMAIL: '/auth/recover-email',
  RECOVER_PASSWORD_CONFIRM: '/auth/recover-password',
  PROFILE: '/profile',
  COMPANY: '/company',
  EDIT_COMPANY: '/edit-company',
  EDIT_PROFILE: '/edit-profile',
  CREATE_COMPANY: '/create-company',
  APPLICATIONS: '/applications',
  APPLICATION_DETAILED: '/application/:appID',
  USER_PERMISSIONS: '/user-permissions',
  MAILING: '/mailing',
  MAILING_ADD_TEMPLATE: '/mailing/add-template/:id',
  MAILING_DETAIL_TEMPLATE: '/mailing/detail-template/:id',
  BONUS_RECORD: '/bonus-record',
  BONUS_RECORD_DETAIL: '/bonus-record/detail/:id',
  COMPANY_PROMOTIONS: '/company-promotions',
  COMPANY_PROMOTIONS_CREATE: '/company-promotions/create',
  COMPANY_PROMOTIONS_EDIT: '/company-promotions/edit/:id',
  COMPANY_PROMOTIONS_COPY: '/company-promotions/copy/:id',
  COMPANY_PROMOTIONS_DETAIL: '/company-promotions/detail/:id',
};

export const getRouteWithParam = (route, param, value) => route.replace(param, value?.toString());
